import { DISABLE_THIRD_PARTY_SCRIPTS } from '@helpers/constants';

interface EventParams {
    [key: string]: any;
}

export function sendGA4ClickEvent(eventName: string, eventParams?: EventParams): void {
    if (DISABLE_THIRD_PARTY_SCRIPTS === true) {
        console.log('sendGA4ClickEvent - DISABLE_THIRD_PARTY_SCRIPTS is true')
        return;
    }
    // Ensure the dataLayer array exists
    const _dataLayer = getWindowDataLayer();

    if (_dataLayer) {
        const eventObject: { event: string;[key: string]: any } = { event: eventName };

        // eslint-disable-next-line no-restricted-syntax
        for (const key in eventParams) {
            if (Object.prototype.hasOwnProperty.call(eventParams, key)) {
                eventObject[key] = eventParams[key];
            }
        }

        _dataLayer.push(eventObject);
        // console.log('GA4 click event sent:', eventObject);
    }
}

const getWindowDataLayer = (): any => {
    const windowDataLayer: any = window['dataLayer'];

    if (typeof windowDataLayer !== 'object' || windowDataLayer === null) {
        throw new Error('dataLayer is not an expected value');
    }

    return windowDataLayer;
};
